// src/route.tsx
import { Button, Result } from "antd";
import {
  Navigate,
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import ActivitiesComponent from "./component/activities-component/activitiesComponent";
import Layouts from "./component/layout/layout";
import ProductComponent from "./component/product-component/productComponent";
import RegisterComponent from "./component/register-component/register-component";
import LoginComponent from "./component/login-component/login-component";
import CheckoutComponent from "./component/checkout-component/checkoutComponent";

function RootBoundary() {
  const error = useRouteError();
  const nav = useNavigate();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return (
        <Result
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Button type="primary" onClick={() => nav("/login")}>
              Back Home
            </Button>
          }
        />
      );
    }

    if (error.status === 401) {
      return <div>You aren't authorized to see this</div>;
    }

    if (error.status === 503) {
      return <div>Looks like our API is down</div>;
    }

    if (error.status === 418) {
      return <div>🫖</div>;
    }
  }

  return <div>Something went wrong</div>;
}

export const routeDetail = [
  {
    path: "/",
    element: <Layouts />, // Home page,
    children: [
      {
        path: "/",
        element: <Navigate to="/login" replace />,
      },
      {
        path: "/login",
        element: <LoginComponent />, // Login page
      },
      {
        path: "/register",
        element: <RegisterComponent />, // Login page
      },

      {
        path: "/home",
        element: <ActivitiesComponent />,
      },
      {
        path: "/products",
        element: <ProductComponent />,
      },
      {
        path: "/checkout",
        element: <CheckoutComponent />,
      },
    ],
  },
];
